module.exports = __webpack_public_path__ + "img/Bild 14 Vitra Corpform-2.ac0ffe6e.jpg";